import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_Time",
  "use": "Ico_Time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Ico_Time\">\n    <path data-name=\"Rectangle 7784\" style=\"fill:none\" d=\"M0 0h24v24H0z\" />\n    <path data-name=\"Path 12304\" d=\"M9.98 2.751a7.2 7.2 0 1 1-7.2 7.2 7.208 7.208 0 0 1 7.2-7.2m0-.8a8 8 0 1 0 8 8 8 8 0 0 0-8-8\" transform=\"translate(2 2)\" style=\"fill:#231f20\" />\n    <path data-name=\"Path 12305\" d=\"M16 12.5h-4.5V7h1v4.5H16z\" style=\"fill:#231f20\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol